import styled from "styled-components";

import breakpoints from "../../../styles/breakpoints";

const GridHolder = styled.div`
  ${breakpoints.smUp} {
    display: flex;
    flex-wrap: wrap;
  }
`;

const GridHolderItemHalf = styled.div`
  ${breakpoints.smUp} {
    width: 50%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
  }
`;

const GridHolderItemContent = styled.div`
  ${breakpoints.smUp} {
    padding: 40px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  ${breakpoints.mdUp} {
    padding: 80px 120px 40px 40px;
  }
  padding: 20px 15px;
  position: relative;
`;

const GridHolderFooterContent = styled.div`
  ${breakpoints.smUp} {
    margin-top: auto;
  }
  padding-top: 20px;
`;

export { GridHolder, GridHolderItemHalf, GridHolderItemContent, GridHolderFooterContent };
